var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Admin schedule for "+_vm._s(_vm.adminId))])}
var staticRenderFns = []

export { render, staticRenderFns }